<template>
  <section>
    <Feature :title="$t('PCB_GROUP_MAINTAIN')" :iconClass="'fa-database'">
      <FormRow :fieldNameArr="[$t('')]">
        <Button type="primary" @click="create" slot="a">{{ $t('ADD') }}</Button>
      </FormRow>
      <TablePage :tableWidth="windowWidth" :columnsList="columnsList" :resultList="dataList" v-if="isData"></TablePage>
    </Feature>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="modal" :title="actionWord"
      @on-ok="confirm">
      <FormRow :fieldNameArr="[$t('GROUP_NAME'), $t('CPC_ACCOUNT')]">
        <Input v-model="pcbGroup.groupName" slot="a" />
        <Input v-model="pcbGroup.cpcAccount" slot="b" />
      </FormRow>
      <FormRow :fieldNameArr="[$t('ENABLED')]" v-if="!isCreated">
        <RadioGroup v-model="enabled" slot="a">
          <Radio label="YES"> {{ $t('YES') }} </Radio>
          <Radio label="NO"> {{ $t('NO') }} </Radio>
        </RadioGroup>
      </FormRow>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { Translate, ExceptionHandling } from "@/util/common"

export default {
  name: "PcbGroup",
  created() {
    search(this)
  },
  data() {
    return {
      isCreated: true,
      enabled: "YES",
      modal: false,
      pcbGroup: {
        groupName: "",
        cpcAccount: ""
      },
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("COMMON_BUTTON_operation")
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "action",
          width: 120,
          align: "center",
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "md-create",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.edit(params.row)
                },
              },
            })
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ENABLED')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 120,
          sortable: true,
          align: "center",
          render: (h, params) => {
            return params.row.enabled
              ? h("Icon", {
                props: {
                  type: "md-checkmark-circle",
                  size: 28,
                },
                class: "text-delta-blue"
              })
              : h("Icon", {
                props: {
                  type: "md-close-circle",
                  size: 28,
                },
                class: "text-delta-red"
              })
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('GROUP_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 200,
          align: 'center',
          key: "groupName",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CPC_ACCOUNT')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 200,
          align: 'center',
          key: "cpcAccount",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('DELTA_USER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 200,
          align: 'center',
          key: "cpcAdAccount",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UPDATE_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 200,
          align: 'center',
          key: "lastModified",
          sortable: true
        },
      ],
      dataList: []
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    create() {
      this.isCreated = true
      this.modal = true
    },
    edit(row) {
      this.isCreated = false
      this.modal = true
      this.pcbGroup = row
      this.enabled = row.enabled ? "YES" : "NO"
    },
    confirm() {
      const vueInstance = this
      if (vueInstance.valid()) {
        createOrUpdate(vueInstance, vueInstance.pcbGroup)
      }
    },
    valid() {
      let errorMessage = ""
      if (!this.pcbGroup.groupName) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('GROUP_NAME') + " <br>"
      }
      if (!this.pcbGroup.cpcAccount) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('CPC_ACCOUNT') + " <br>"
      }
      if (errorMessage) {
        AlertInfo(this, errorMessage).then(() => {
        })
      }
      return errorMessage == ""
    }
  },
  computed: {
    actionWord() {
      return this.isCreated ? this.$t('ADD') : this.$t('UPDATE')
    },
    modalSize() {
      return this.getModalSize()
    },
    isData() {
      return this.dataList && this.dataList.length > 0
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  }
}

function search(vueInstance) {
  vueInstance.toggleLoading(true)
  vueInstance.$quotationHttp
    .get("/pcbGroup/find")
    .then((response) => {
      console.log(response)
      vueInstance.toggleLoading(false)
      if (response.data._embedded) {
        vueInstance.dataList = response.data._embedded.pcbGroupResourceList
      }
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}

function createOrUpdate(vueInstance, data) {
  let action = "create"
  vueInstance.toggleLoading(true)
  if (!vueInstance.isCreated) {
    action = "update"
    vueInstance.pcbGroup.enabled = vueInstance.enabled == "YES" ? true : false
    vueInstance.dataList.splice(vueInstance.pcbGroup._index, 1)
  }
  vueInstance.$quotationHttp
    .post("/pcbGroup/" + action, JSON.stringify(data))
    .then((response) => {
      vueInstance.toggleLoading(false)
      vueInstance.dataList.unshift(response.data)
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}
</script>

<style scoped></style>
